// Handle click on answer items to expand/collapse actions
// Only applies when there are multiple items in the list
document.addEventListener('click', function(event) {
  const answerItem = event.target.closest('.answer-item')
  if (answerItem) {
    // Check if this is part of a list with multiple items
    const parentList = answerItem.closest('.answers-list')
    if (parentList) {
      const itemCount = parentList.querySelectorAll('.answer-item').length
      // Only toggle if there are multiple items
      if (itemCount <= 1) {
        return
      }
    }

    // Don't toggle if clicking on a button or interactive element
    const clickedElement = event.target
    const isInteractive = clickedElement.closest('.btn, .btn-chat-action, button, a, form, input')

    if (!isInteractive) {
      answerItem.classList.toggle('expanded')
    }
  }
})
